import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import "./index.css"
import DrawerWrapper from "../../sections/DrawerWrapper"
import Details from "./sections/tabs/details/Details"
import Payments from "./sections/tabs/payments/Payments"
import { HomeView } from "../../sections/views/Views"
import { useRoom } from "../../hooks"
import { Block, Tabs } from "../../sections/elements/Elements"
import LockRoom from "../../Modals/LockRoom/LockRoom"
import ReportIncidence from "../../Modals/ReportIncidence/ReportIncidence"
import useSnackbar from "src/shared/hooks/useSnackbar"
import CambioHabitacion from "./sections/cambio-habitacion/CambioHabitacion"
import ConfirmarCambioHabitacion from "./sections/confirmar-cambio-habitacion/ConfirmarCambioHabitacion"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "src/store/store"
import { ReservadaDrawerSections, selectReservadaDrawerSection, selectReservation } from "src/store/roomDetails/reservadaSlice"
import { startGetRooms } from "src/pages/home/store/thunks/rooms.thunk"
import { useProfile } from "src/shared/hooks/useProfile"
import { useDate } from "src/shared/hooks/useDate"
import { useFormatDate } from "src/shared/hooks/useFormatDate"
import { capitalize } from "src/shared/helpers/capitalize"
import { toggleRoomDetailsDrawer } from "src/store/navigation/navigationSlice"
import LoaderComponent from "src/shared/components/layout/loader/Loader"
import { useCloseDrawer } from "../../helpers/useCloseDrawer"
import { useCancelarReservaMutation, useGetReservacionByIdLazyQuery, EstadosReservas, useRemoverReservaHabitacionMutation, ModalidadGrupoTarifa } from "src/gql/schema"
import CancelarReserva from "../../Modals/CancelarReserva/CancelarReserva"
import useIsColaboradorActive from "src/shared/hooks/useIsColaboradorActive"
import EditarReserva from "../../Modals/EditarReserva/EditarReserva"
import { RoleNames } from "src/shared/hooks/useAuth"
import { useRoomDarwer } from "../../hooks/darwer"
import { useCancelaciones } from "src/shared/hooks/useCancelaciones"
import AlertBase from "src/pages/Cortes/Components/Modals/PagosPendientes"
import useMiniSnackbar from "src/shared/hooks/useMiniSnackbar"

export const homeTabsList: { label: string; path: ReservadaDrawerSections; number: number }[] = [
    { label: "Detalles", path: "details", number: 0 },
    { label: "Pagos", path: "payments", number: 0 },
]

const Reservada = () => {
    const room = useRoom()
    const { onClose } = useRoomDarwer()
    const { drawerSelectedSection, reservaSeleccionada } = useSelector((root: RootState) => root.roomDetails.reservada)
    const { isRoomDetailsDrawerOpen } = useSelector((root: RootState) => root.navigation)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { usuario_id, rolName, hotel_id, zona_horaria } = useProfile()
    const [cancelarReserva] = useCancelarReservaMutation()
    const [removerReserva] = useRemoverReservaHabitacionMutation()
    const { InactiveModal, validateIsColabActive } = useIsColaboradorActive()

    const [isLockRoomModalOpen, setIsLockRoomModalOpen] = useState<boolean>(false)
    const [isCancelarReserevaModalOpen, setIsCancelarReserevaModalOpen] = useState<boolean>(false)
    const [isDesanclarReserevaModalOpen, setIsDesanclarReserevaModalOpen] = useState<boolean>(false)
    const [isEditarReserevaModalOpen, setIsEditarReserevaModalOpen] = useState<boolean>(false)
    const [isReportIncidenceModalOpen, setIsReportIncidenceModalOpen] = useState<boolean>(false)
    const { setHHMMSS, UTCStringToLocalDate } = useDate(zona_horaria)
    const { nowHotel } = useFormatDate()
    const { showSnackbar } = useSnackbar()
    const { showMiniSnackbar } = useMiniSnackbar()
    const { handlePrintTicketOnCancelacion } = useCancelaciones()

    const [isNoShow, setisNoShow] = useState<boolean>(false)
    const [codigoOTA, setCodigoOTA] = useState<string>("")
    const [corteID, setCorteID] = useState<string>("")

    const [noShowDate, setNoShowDate] = useState<number>(0)
    
    useEffect(() => {
        const ultimaTarifa = reservaSeleccionada?.reservas_tarifas?.reduce((prev, curr) =>
            new Date(curr.fecha_fin) > new Date(prev.fecha_fin) ? curr : prev
        )
        const checkOutDate = setHHMMSS({
            startDate: UTCStringToLocalDate(reservaSeleccionada?.fecha_salida),
            newHour: ultimaTarifa?.tarifa?.hora_checkout || "12:00:00-06",
        })
        setNoShowDate(checkOutDate.getTime() + 60 * 1000)
    }, [reservaSeleccionada])

    const [getReserva] = useGetReservacionByIdLazyQuery()

    useEffect(() => {
        if (reservaSeleccionada?.reserva_id) {
            getReserva({
                variables: {
                    id: [reservaSeleccionada.reserva_id],
                },
            }).then((data) => {
                setCorteID(data.data?.reservas[0].corte_id || "")
                setCodigoOTA(data.data?.reservas?.[0].codigo_ota || "")
            })
        }
    }, [reservaSeleccionada])

    const [isLoading, setIsLoading] = useState(false)
    const { closeDrawer } = useCloseDrawer(() => {
        setIsLoading(false)
    })
    const [showMenu, setShowMenu] = useState(true)
    useEffect(() => {
        setShowMenu(
            !(
                rolName === RoleNames.mantenimiento ||
                drawerSelectedSection === "ConfirmarCambioHabitacion" ||
                drawerSelectedSection === "reasignarHabitacion" ||
                reservaSeleccionada?.estado === EstadosReservas.Cancelada
            )
        )
    }, [rolName, drawerSelectedSection, reservaSeleccionada?.estado,])

    useEffect(() => {
        if (!noShowDate) return
        const noShowTime = new Date(noShowDate).getTime()
        if (isNaN(noShowTime)) return
        if (nowHotel.getTime() > noShowTime) {
            setisNoShow(true)
        } else {
            setisNoShow(false)
        }
    }, [nowHotel, noShowDate])

    useEffect(() => {
        if (!isRoomDetailsDrawerOpen) {
            dispatch(selectReservadaDrawerSection("details"))
        }
    }, [isRoomDetailsDrawerOpen])

    const visibleTabs = homeTabsList.filter((tab) => {
        if (rolName === RoleNames.mantenimiento && tab.path === "payments") return false
        return true
    })
    const getLastComment = (comentarios: any[]) => {
        if (!comentarios?.length) return null

        return comentarios.reduce((latest, current) =>
            new Date(current.fecha) > new Date(latest.fecha) ? current : latest
        ).comentario
    }

    const transformarDatosReserva = (reservaSeleccionada) => {
        if (!reservaSeleccionada) return null
        const ultimoComentario = getLastComment(reservaSeleccionada.comentarios)

        const fechaRegistro = UTCStringToLocalDate(reservaSeleccionada.fecha_entrada)
        const fechaSalida = UTCStringToLocalDate(reservaSeleccionada.fecha_salida)

        const tarifas = reservaSeleccionada?.reservas_tarifas || []
        const tarifasSeleccionadas = tarifas
            .filter((rt) => rt.tarifa?.grupo_tarifa?.modalidad !== ModalidadGrupoTarifa.Adicional)
            .map((rt) => ({ tarifa_id: rt.tarifa_id }))
        const tarifasAdicionalesSeleccionadas = tarifas
            .filter((rt) => rt.tarifa?.grupo_tarifa?.modalidad === ModalidadGrupoTarifa.Adicional)
            .map((rt) => ({ tarifa_id: rt.tarifa_id }))

        return {
            fechaReserva: [fechaRegistro, fechaSalida],
            tipoHabitacion: reservaSeleccionada.tipo_de_habitacion?.nombre || "",
            tipoHabitacionId: reservaSeleccionada.tipo_habitacion_id,
            habitacionId: reservaSeleccionada.habitacion_id || "",
            codigoReserva: codigoOTA,
            cantidadPersonasExtra: reservaSeleccionada.personas_extras,
            cantidadPersonas: reservaSeleccionada.numero_personas,
            costoTarifa: reservaSeleccionada.tarifa?.costo_habitacion,
            costoPersonaExtra: reservaSeleccionada.tarifa?.costo_persona_extra,
            origenReserva: reservaSeleccionada.origen,
            tarifasSeleccionadas: tarifasSeleccionadas,
            tarifasAdicionalesSeleccionadas: tarifasAdicionalesSeleccionadas,
            descuentoId: reservaSeleccionada.descuento_aplicado?.descuento_id || "",
            descuento: reservaSeleccionada.descuento_aplicado?.data_descuento?.monto_calculado || 0,
            horaCheckIn: reservaSeleccionada.reservas_tarifas?.[0]?.tarifa?.hora_checkin,
            horaCheckOut: reservaSeleccionada.reservas_tarifas?.[0]?.tarifa?.hora_checkout,
            experienciasSaved: reservaSeleccionada.experiencias_reserva?.map((exp) => exp.experiencia_id) || [],
            folioSaved: reservaSeleccionada.folio,
            reservaIdSaved: reservaSeleccionada.reserva_id,
            nombreHuespedSaved: reservaSeleccionada.nombre_huesped,
            telefonoHuespedSaved: reservaSeleccionada.telefono_huesped,
            emailHuespedSaved: reservaSeleccionada.correo_huesped,
            estadoPagoSaved: reservaSeleccionada.estado_pago,
            estadoReserva: reservaSeleccionada.estado,
            totalSaved: reservaSeleccionada.total,
            pagosSaved: reservaSeleccionada.pagos,
            comentarioSaved: ultimoComentario,
        }
    }

    const handleReservaEdit = () => {
        if (reservaSeleccionada && reservaSeleccionada.reserva_id) {
            const transformedDatosReserva = transformarDatosReserva(reservaSeleccionada)
            navigate(`/u/registro-reserva/${reservaSeleccionada?.reserva_id}`, {
                state: { reservaEdit: transformedDatosReserva },
            })
            onClose()
        }
    }
    return (
        <DrawerWrapper
            withBackButton={
                drawerSelectedSection === "reasignarHabitacion" || drawerSelectedSection === "ConfirmarCambioHabitacion"
            }
            onBack={() => dispatch(selectReservadaDrawerSection("details"))}
            withMenu={showMenu}
            itemsMenu={[
                {
                    label: "Reportar incidencia",
                    onClick: validateIsColabActive(() => {
                        setIsReportIncidenceModalOpen(true)
                    }),
                },
                {
                    label: "Bloquear habitación",
                    onClick: validateIsColabActive(() => {
                        setIsLockRoomModalOpen(true)
                    }),
                },
                ...(reservaSeleccionada?.estado === EstadosReservas.Asignada
                    ? [
                        {
                            label: "Editar reservación",
                            onClick: validateIsColabActive(() => setIsEditarReserevaModalOpen(true)),
                            disabled: !!reservaSeleccionada?.descuento_aplicado ||
                            !!reservaSeleccionada?.extras?.some((extra) => !!extra?.descuento_aplicado),
                        },
                        {
                            label: "Desanclar reserva",
                            onClick: validateIsColabActive(() => {
                                if (reservaSeleccionada) {
                                    setIsDesanclarReserevaModalOpen(true)
                                }
                            }),
                        },
                    ]
                    : []),
                ...(reservaSeleccionada?.estado !== EstadosReservas.Asignada &&
                    reservaSeleccionada?.estado !== EstadosReservas.Cancelada
                    ? [
                        {
                            label: "Cancelar reserva",
                            onClick: validateIsColabActive(() => {
                                if (reservaSeleccionada) {
                                    setIsCancelarReserevaModalOpen(true)
                                }
                            }),
                            disabled: corteID === "" ? false : true,
                        },
                    ]
                    : []),
            ]}
        >
            {drawerSelectedSection === "reasignarHabitacion" ? (
                <CambioHabitacion />
            ) : drawerSelectedSection === "ConfirmarCambioHabitacion" ? (
                <ConfirmarCambioHabitacion />
            ) : (
                <HomeView
                    title={`${room?.tipo_habitacion?.nombre} ${room?.numero_habitacion}`}
                    subtitle={
                        isNoShow
                            ? `No show - ${capitalize(reservaSeleccionada?.origen || "")} ${reservaSeleccionada?.folio}`
                            : ""
                    }
                    subtitleStyle={{
                        color: isNoShow ? "var(--Ocupado, #EB5757)" : "",
                    }}
                >
                    <div>
                        <Block>
                            <Tabs
                                value={drawerSelectedSection}
                                onChange={(value) =>
                                    dispatch(selectReservadaDrawerSection(value as ReservadaDrawerSections))
                                }
                                tabList={visibleTabs}
                                className="room-detail--occupied__tabs"
                            />
                            {drawerSelectedSection === "details" ? (
                                <Details
                                    isNoShow={isNoShow}
                                    onReasignarHabitacion={() =>
                                        dispatch(selectReservadaDrawerSection("reasignarHabitacion"))
                                    }
                                />
                            ) : drawerSelectedSection === "payments" ? (
                                <Payments isNoShow={isNoShow} />
                            ) : (
                                <></>
                            )}
                        </Block>
                    </div>
                </HomeView>
            )}

            <LockRoom isOpen={isLockRoomModalOpen} onClose={() => setIsLockRoomModalOpen(false)} />
            <ReportIncidence isOpen={isReportIncidenceModalOpen} onClose={() => setIsReportIncidenceModalOpen(false)} />
            <EditarReserva
                visible={isEditarReserevaModalOpen}
                editMode={false}
                onClose={() => setIsEditarReserevaModalOpen(false)}
                onConfirm={handleReservaEdit}
            />
            <CancelarReserva
                isOpen={isCancelarReserevaModalOpen}
                title="Cancelación de reservación"
                subtitle={
                    (codigoOTA && codigoOTA + " / ") + `ER-${reservaSeleccionada?.folio?.toString().padStart(3, "0")}`
                }
                ota={codigoOTA ? true : false}
                onClose={() => {
                    setIsCancelarReserevaModalOpen(false)
                }}
                onCancelError={() => {
                    showSnackbar({
                        title: "Error al cancelar reserva",
                        status: "error",
                        text: "¡Ups! Se ha producido un error. Por favor, inténtalo nuevamente",
                    })
                }}
                onConfirm={(data) => {
                    setIsLoading(true)
                    cancelarReserva({
                        variables: {
                            cancelar_reserva_input: {
                                monto_devuelto_cancelacion: data.presupuesto,
                                motivo_cancelacion: data.otroMotivoCancelacion || data.motivoCancelacion,
                                reserva_id: reservaSeleccionada?.reserva_id || "",
                                usuario_id: usuario_id,
                            },
                            codigo: data.codigo || "",
                            template_sample: data.template_sample || "",
                        },
                    })
                        .then((data) => {
                            const ticket_id = data?.data?.cancelar_reserva.ticket_ids || []
                            handlePrintTicketOnCancelacion(ticket_id)
                            dispatch(selectReservation({
                                ...reservaSeleccionada,
                                estado: EstadosReservas.Cancelada,
                            }))
                            dispatch(startGetRooms({}))
                            dispatch(toggleRoomDetailsDrawer(false))
                            showSnackbar({
                                title: "Reservación cancelada",
                                status: "success",
                                text: `La habitación **${room?.tipo_habitacion?.nombre} ${room?.numero_habitacion}** paso de **reservada a la venta**`,
                            })
                        })
                        .catch(() => {
                            showSnackbar({
                                title: "Error cancelar reserva",
                                text: "¡Ups! Se ha producido un error. Por favor, inténtalo nuevamente.",
                                status: "error",
                            })
                        })
                        .finally(() => {
                            closeDrawer()
                        })
                }}
            />
            {isDesanclarReserevaModalOpen && (
                <AlertBase
                    visible={true}
                    title={"Liberación de habitación reservada"}
                    description={`Si decides dar clic en “Continuar”, ten en cuenta que deberás asignar nuevamente la reserva a una habitación.`}
                    withCancelOption
                    cancelLabel="Cancelar"
                    confirmLabel="Continuar"
                    onClose={() => setIsDesanclarReserevaModalOpen(false)}
                    onConfirm={() => {
                        setIsLoading(true)
                        removerReserva({
                            variables: {
                                input: {
                                    usuario_id,
                                    habitacion_id: room?.habitacion_id || "",
                                    hotel_id
                                }
                            },
                        })
                            .then(() => {
                                dispatch(startGetRooms({}))
                                dispatch(toggleRoomDetailsDrawer(false))
                                showMiniSnackbar({
                                    title: "Habitación liberada",
                                    status: "success",
                                    text: `La habitación **${room?.tipo_habitacion?.nombre} ${room?.numero_habitacion}** pasa de **reservada** a **preparada**`,
                                })
                            })
                            .catch(() => {
                                showMiniSnackbar({
                                    title: "Error al liberar habitación",
                                    text: "¡Ups! Se ha producido un error. Por favor, inténtalo nuevamente.",
                                    status: "error",
                                })
                            })
                            .finally(() => {
                                closeDrawer()
                                setIsDesanclarReserevaModalOpen(false)
                                setIsLoading(false)
                            })
                    }}
                />
            )}
            <LoaderComponent visible={isLoading} />
            {InactiveModal}
        </DrawerWrapper>
    )
}

export default Reservada
